import "./EndBranding.css";

type EndBrandingProps = {
}

export const EndBranding = ({}: EndBrandingProps) => {
    return (
        <div 
            className="end-branding"
            onClick={() => window.open("https://effno.co", "_blank")}
        >
            <div className="end-branding-title">
                Build your own <a href="https://effno.co">effno forms</a> for free
            </div>
            <div 
                className="end-branding-navigate"
            >
                Powered by&nbsp;<b>effno</b>
            </div>
        </div>
    )
}